import EmptyDialog from "empty_dialog";

export default EmptyDialog;